import React, { useEffect } from 'react'
import Image from "next/legacy/image"
import ZipGrid from './ZipGrid'
import ZipCards from './ZipCards'
import TermsAndConditions from './TermsAndConditions'
import styles from './index.module.css'

const ModalZip = ({ onRequestClose }) => {
  useEffect(() => {
    function onKeyDown(event) {
      if (event.keyCode === 27) {
        // Close the modal when the Escape key is pressed
        onRequestClose()
      }
    }

    // Prevent scolling
    document.body.style.overflow = 'hidden'
    document.addEventListener('keydown', onKeyDown)

    // Clear things up when unmounting this component
    return () => {
      document.body.style.overflow = 'visible'
      document.removeEventListener('keydown', onKeyDown)
    }
  })

  return (
    <div className={styles.modal__backdrop}>
      <div className={styles.modal__container}>
        <div className={styles.modal__body}>
          <div className={styles.modal__closeBtn_wrapper}>
            <img
              onClick={onRequestClose}
              className={styles.modal__closeBtn}
              src="/icons/modalCloseBtn.png"
              alt="Close"
            />
          </div>
          <div className={styles.modal__logo}>
            <Image
              width={67}
              height={24}
              src="/icons/logo-zip.svg"
              alt="Zip"
              unoptimized
            />
          </div>
          <div className={styles.modal__first_section}>
            <p className={styles.modal__title}>An account for everyone</p>
            <p className={styles.modal__sub_title}>
              Choose the buy now, pay later account that suits you best.
            </p>
          </div>
          <ZipGrid />
          <ZipCards />
          <TermsAndConditions />
        </div>
      </div>
    </div>
  )
}

export default ModalZip
